import * as yup from 'yup';
import ITNewsletterForm from '../../interfaces/newsletter/newsletter';

export const newsletterFormInitialValues: ITNewsletterForm = {
	name: '',
	email: '',
	postalCode: null,
	individuals: true,
	companies: false,
	gdpr: false,
};

export const newsletterSchema = yup.object().shape({
	name: yup.string().required('nameRequired'),
	email: yup.string().email('emailNotValid').required('emailRequired'),
	companies: yup
		.boolean()
		.when('individuals', { is: false, then: yup.boolean().oneOf([true], 'newsletterRequired') }),
	// captchaValid: yup.boolean().test('is-valid-captcha', 'captcha-valid', value => value),
	gdpr: yup.boolean().oneOf([true], 'required'),
});
